import React from 'react';
import Navbar from '../components/Navbar';
import InnerLeadBanner from '../components/InnerLeadBanner';

const TermsAndConditions = () => {
    return (
        <>
            <Navbar/>
            <InnerLeadBanner title='Terms and Conditions' />
            
            <section className="terms-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="terms-content">
                                <div className="last-updated">
                                    <p><strong>Last Updated:</strong> October 28, 2023</p>
                                </div>
                                
                                <div className="intro-section mb-5">
                                    <h2>JobFlow Online Terms and Conditions</h2>
                                    <p>
                                        Welcome to JobFlow Online ("Platform," "we," "our," or "us"). These Terms and Conditions 
                                        govern your use of our website and services. Please read these terms carefully before 
                                        using our Platform.
                                    </p>
                                    <p>
                                        By accessing or using JobFlow Online, you agree to be bound by these Terms and Conditions. 
                                        If you do not agree with any part of these terms, you must not use our services.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>1. Acceptance of Terms</h3>
                                    <p>
                                        By creating an account or using JobFlow Online, you acknowledge that you have read, 
                                        understood, and agree to be bound by these Terms and Conditions, our Privacy Policy, 
                                        and any additional terms that may apply to specific services.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>2. Definitions</h3>
                                    <ul>
                                        <li><strong>"Platform"</strong> refers to JobFlow Online website and mobile applications</li>
                                        <li><strong>"User"</strong> refers to any individual or entity using the Platform</li>
                                        <li><strong>"Job Seeker"</strong> refers to users seeking employment opportunities</li>
                                        <li><strong>"Employer"</strong> refers to users posting job opportunities</li>
                                        <li><strong>"Content"</strong> refers to any text, images, videos, or other materials posted on the Platform</li>
                                        <li><strong>"Services"</strong> refers to all features and functionality provided by JobFlow Online</li>
                                    </ul>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>3. User Accounts</h3>
                                    
                                    <h4>3.1 Account Registration</h4>
                                    <p>To access certain features, you must register for an account. You agree to:</p>
                                    <ul>
                                        <li>Provide accurate, current, and complete information</li>
                                        <li>Maintain and promptly update your account information</li>
                                        <li>Maintain the security of your password</li>
                                        <li>Accept responsibility for all activities under your account</li>
                                        <li>Notify us immediately of any unauthorized use of your account</li>
                                    </ul>

                                    <h4>3.2 Account Types</h4>
                                    <p><strong>Job Seekers:</strong> Individuals seeking employment opportunities</p>
                                    <p><strong>Employers:</strong> Companies or individuals posting job opportunities</p>
                                    <p>You may not maintain more than one account without our written permission.</p>

                                    <h4>3.3 Account Termination</h4>
                                    <p>
                                        We reserve the right to suspend or terminate your account at our sole discretion 
                                        if we believe you have violated these Terms and Conditions.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>4. Job Seeker Responsibilities</h3>
                                    <p>As a Job Seeker, you agree to:</p>
                                    <ul>
                                        <li>Provide accurate and truthful information in your profile and applications</li>
                                        <li>Not apply for jobs for which you are not qualified</li>
                                        <li>Respect employer confidentiality and application processes</li>
                                        <li>Not misuse employer contact information</li>
                                        <li>Comply with all applicable laws and regulations</li>
                                        <li>Not engage in fraudulent or deceptive practices</li>
                                    </ul>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>5. Employer Responsibilities</h3>
                                    <p>As an Employer, you agree to:</p>
                                    <ul>
                                        <li>Post only legitimate job opportunities</li>
                                        <li>Provide accurate and complete job descriptions</li>
                                        <li>Comply with all applicable employment laws</li>
                                        <li>Not discriminate based on race, gender, religion, age, or other protected characteristics</li>
                                        <li>Respond to applications in a timely manner</li>
                                        <li>Maintain the confidentiality of applicant information</li>
                                        <li>Not charge fees to job applicants</li>
                                        <li>Not post pyramid schemes or illegal opportunities</li>
                                    </ul>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>6. Prohibited Content and Activities</h3>
                                    <p>You may not post content or engage in activities that:</p>
                                    <ul>
                                        <li>Are illegal, fraudulent, or misleading</li>
                                        <li>Infringe on intellectual property rights</li>
                                        <li>Contain viruses or malicious code</li>
                                        <li>Harass, threaten, or discriminate against others</li>
                                        <li>Contain sexually explicit or offensive material</li>
                                        <li>Promote pyramid schemes or multi-level marketing</li>
                                        <li>Involve unauthorized advertising or spam</li>
                                        <li>Attempt to reverse engineer or hack the Platform</li>
                                        <li>Impersonate another person or entity</li>
                                    </ul>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>7. Intellectual Property</h3>
                                    
                                    <h4>7.1 Platform Content</h4>
                                    <p>
                                        All content on JobFlow Online, including text, graphics, logos, and software, 
                                        is our property or licensed to us and protected by intellectual property laws.
                                    </p>

                                    <h4>7.2 User Content</h4>
                                    <p>
                                        You retain ownership of content you post on the Platform. By posting content, 
                                        you grant us a worldwide, non-exclusive license to use, display, and distribute 
                                        your content for the purpose of providing our services.
                                    </p>

                                    <h4>7.3 Restrictions</h4>
                                    <p>You may not:</p>
                                    <ul>
                                        <li>Copy, modify, or distribute Platform content without permission</li>
                                        <li>Use our trademarks or logos without written consent</li>
                                        <li>Scrape or collect data from the Platform without authorization</li>
                                    </ul>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>8. Fees and Payments</h3>
                                    
                                    <h4>8.1 Free Services</h4>
                                    <p>Basic job searching and posting features are available free of charge.</p>

                                    <h4>8.2 Premium Services</h4>
                                    <p>Certain enhanced features may require payment. Fees will be clearly displayed before purchase.</p>

                                    <h4>8.3 Payment Terms</h4>
                                    <ul>
                                        <li>All fees are non-refundable unless otherwise stated</li>
                                        <li>We may change fees with 30 days' notice</li>
                                        <li>You are responsible for any taxes applicable to your purchases</li>
                                    </ul>

                                    <h4>8.4 Subscription Cancellation</h4>
                                    <p>
                                        You may cancel premium subscriptions at any time, but no refunds will be provided 
                                        for unused portions of the subscription period.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>9. Privacy</h3>
                                    <p>
                                        Your privacy is important to us. Our collection and use of your personal information 
                                        is governed by our Privacy Policy, which is incorporated into these Terms and Conditions.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>10. Third-Party Links and Content</h3>
                                    <p>
                                        Our Platform may contain links to third-party websites or services. We are not responsible 
                                        for the content or practices of these third parties. Your interactions with third-party 
                                        sites are solely between you and the third party.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>11. Disclaimer of Warranties</h3>
                                    <p>
                                        THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
                                        EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT:
                                    </p>
                                    <ul>
                                        <li>THE PLATFORM WILL BE UNINTERRUPTED OR ERROR-FREE</li>
                                        <li>JOB LISTINGS ARE ACCURATE OR LEGITIMATE</li>
                                        <li>JOB SEEKERS WILL FIND EMPLOYMENT</li>
                                        <li>EMPLOYERS WILL FIND SUITABLE CANDIDATES</li>
                                    </ul>
                                    <p>
                                        We are not responsible for the actions or content of users. You use the Platform at your own risk.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>12. Limitation of Liability</h3>
                                    <p>
                                        TO THE MAXIMUM EXTENT PERMITTED BY LAW, JOBFLOW ONLINE AND ITS AFFILIATES SHALL NOT BE LIABLE FOR:
                                    </p>
                                    <ul>
                                        <li>ANY INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES</li>
                                        <li>LOSS OF PROFITS, DATA, OR BUSINESS OPPORTUNITIES</li>
                                        <li>UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR CONTENT</li>
                                        <li>ACTIONS OR OMISSIONS OF OTHER USERS</li>
                                        <li>JOB-RELATED DISPUTES BETWEEN EMPLOYERS AND JOB SEEKERS</li>
                                    </ul>
                                    <p>
                                        Our total liability to you for any claim shall not exceed the amount paid by you to us 
                                        in the six months preceding the claim.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>13. Indemnification</h3>
                                    <p>
                                        You agree to indemnify and hold harmless JobFlow Online, its officers, directors, 
                                        employees, and agents from any claims, damages, or expenses arising from:
                                    </p>
                                    <ul>
                                        <li>Your use of the Platform</li>
                                        <li>Your violation of these Terms and Conditions</li>
                                        <li>Your violation of any rights of another party</li>
                                        <li>Your interactions with other users</li>
                                    </ul>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>14. Termination</h3>
                                    <p>These Terms and Conditions remain in effect while you use our services.</p>
                                    <p>We may terminate or suspend your account at any time for any reason, including:</p>
                                    <ul>
                                        <li>Violation of these Terms and Conditions</li>
                                        <li>Requests by law enforcement</li>
                                        <li>Unexpected technical or security issues</li>
                                        <li>Extended periods of inactivity</li>
                                    </ul>
                                    <p>You may terminate your account at any time by contacting us or using account deletion features.</p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>15. Dispute Resolution</h3>
                                    
                                    <h4>15.1 Governing Law</h4>
                                    <p>These Terms and Conditions shall be governed by the laws of the Republic of Ghana.</p>

                                    <h4>15.2 Arbitration</h4>
                                    <p>
                                        Any disputes arising from these terms shall be resolved through binding arbitration 
                                        in Accra, Ghana, in accordance with Ghanaian arbitration laws.
                                    </p>

                                    <h4>15.3 Class Action Waiver</h4>
                                    <p>
                                        You agree to resolve disputes on an individual basis and waive any right to participate 
                                        in class actions or representative proceedings.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>16. Changes to Terms</h3>
                                    <p>
                                        We may modify these Terms and Conditions at any time. We will notify you of material 
                                        changes by posting the updated terms on our Platform and updating the "Last Updated" date.
                                    </p>
                                    <p>
                                        Your continued use of the Platform after changes constitutes acceptance of the modified terms.
                                    </p>
                                </div>

                                <div className="terms-section mb-4">
                                    <h3>17. Contact Information</h3>
                                    <p>For questions about these Terms and Conditions, please contact us:</p>
                                    <div className="contact-info">
                                        <p><strong>Email:</strong> <a href="mailto:legal@jobflowonline.com">legal@jobflowonline.com</a></p>
                                        <p><strong>Phone:</strong> +233 559 801 548</p>
                                        <p><strong>Address:</strong> 
                                            <br />
                                            JobFlow Online
                                            <br />
                                            PMB CT 243, Cantonments
                                            <br />
                                            Accra, Ghana
                                        </p>
                                    </div>
                                </div>

                                <div className="terms-section">
                                    <h3>18. Severability</h3>
                                    <p>
                                        If any provision of these Terms and Conditions is found to be invalid or unenforceable, 
                                        the remaining provisions shall remain in full force and effect.
                                    </p>
                                </div>

                                <div className="acknowledgement mt-5 p-4 bg-light rounded">
                                    <h4>Important Notice</h4>
                                    <p>
                                        <strong>JobFlow Online is a platform that connects job seekers and employers. 
                                        We are not a party to any employment agreements and do not guarantee employment 
                                        or hiring outcomes. Users are solely responsible for their interactions and 
                                        employment decisions.</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .terms-section {
                    padding: 50px 0;
                    background-color: #f8f9fa;
                }
                
                .terms-content {
                    background: white;
                    padding: 40px;
                    border-radius: 10px;
                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
                    line-height: 1.7;
                }
                
                .last-updated {
                    background: #e9ecef;
                    padding: 15px;
                    border-radius: 5px;
                    margin-bottom: 30px;
                    text-align: center;
                }
                
                .intro-section {
                    border-bottom: 2px solid #667eea;
                    padding-bottom: 20px;
                }
                
                .terms-section h3 {
                    color: #667eea;
                    margin-bottom: 15px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e9ecef;
                }
                
                .terms-section h4 {
                    color: #495057;
                    margin: 20px 0 10px;
                    font-size: 1.1rem;
                }
                
                .terms-section ul {
                    padding-left: 20px;
                    margin-bottom: 15px;
                }
                
                .terms-section li {
                    margin-bottom: 8px;
                    line-height: 1.6;
                }
                
                .terms-section strong {
                    color: #495057;
                }
                
                .contact-info {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 5px;
                    margin-top: 15px;
                }
                
                .contact-info a {
                    color: #667eea;
                    text-decoration: none;
                }
                
                .contact-info a:hover {
                    text-decoration: underline;
                }
                
                .acknowledgement {
                    border-left: 4px solid #667eea;
                }
                
                .acknowledgement h4 {
                    color: #495057;
                    margin-bottom: 10px;
                }
                
                @media (max-width: 768px) {
                    .terms-content {
                        padding: 20px;
                    }
                    
                    .terms-section h3 {
                        font-size: 1.3rem;
                    }
                }
            `}</style>
        </>
    );
};

export default TermsAndConditions;